import { render } from "./dl-icon.vue?vue&type=template&id=c9cd0de6"
import script from "./dl-icon.vue?vue&type=script&lang=js"
export * from "./dl-icon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__